import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

import { NgbModal, NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { has, filter } from 'lodash';

import { BrigadesService } from '../../brigades.service';

import { CreateNewBrigadeModalComponent } from '../../modals/create-new-brigade-modal/create-new-brigade-modal.component';
import { MoveUserNewBrigadeModalComponent } from '../../modals/move-user-new-brigade-modal/move-user-new-brigade-modal.component';
import { ConfirmModalComponent } from '../../../../../../../shared/modals/confirm-modal/confirm-modal.component';
import { RemoveUserFromBrigadeComponent } from '../../modals/remove-user-from-brigade/remove-user-from-brigade.component';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-user-actions-popover',
  templateUrl: './user-actions-popover.component.html',
  styleUrls: ['./user-actions-popover.component.scss'],
  standalone: false,
})
export class UserActionsPopoverComponent implements OnInit {
  @Input() index;
  @Input() user;
  @Input() brigade;
  @Input() sector;
  @Output() onUpdateWidget = new EventEmitter<any>();
  // TODO автоподстраивание работает некрасиво в данном кейсе, вычисляем каждого шестого
  //  монтажника и смещает поповер вниз влево
  public indexes = [6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 108, 114, 120];
  public placement;

  constructor(
    public modalService: NgbModal,
    public brigadesService: BrigadesService
  ) {}

  ngOnInit() {
    this.placement = this.indexes.indexOf(this.index) > -1 ? 'bottom-right' : 'bottom';
  }

  public toggleWithUserActionsContext(popover: NgbPopover) {
    if (popover.isOpen()) {
      popover.close();
    } else {
      popover.open();
    }
  }

  public showOnlyTraineesWarning() {
    let moveUserErrorDialog = this.modalService.open(ConfirmModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    moveUserErrorDialog.componentInstance.title = 'Бригада не может состоять из стажеров';
    moveUserErrorDialog.componentInstance.description = (
      'Невозможно применить действие, ' + 'так как бригада не может состоять из стажеров.'
    );
    moveUserErrorDialog.componentInstance.successButtonName = 'Закрыть';
  }

  public checkMainEmployers() {
    const mainEmployers = filter(this.brigade.brigade_workers, (w: any) => w.employer.employee_type.et_id === 2);

    return mainEmployers.length > 0;
  }

  public checkWorkersInBrigade() {
    return this.brigade.brigade_workers.length > 0;
  }

  public getMainEmployers() {
    return filter(this.brigade.brigade_workers, (worker: any) => worker.employer.employee_type.et_id === 2);
  }

  public onOpenCreateBrigadeDialog() {
    let create_type;

    if (has(this.user, 'brigade') && !this.user.brigade && !this.brigade) {
      create_type = 1;
    } else if (this.user && this.brigade && this.user.u_id === this.brigade.brigade_head.u_id) {
      create_type = 2;

      if (!this.checkMainEmployers()) {
        this.showOnlyTraineesWarning();
        return;
      }
    } else if (this.user && this.brigade && this.user.u_id !== this.brigade.brigade_head.u_id) {
      this.createNewBrigade();
      return;
    }

    let createBrigadeDialog = this.modalService.open(CreateNewBrigadeModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    if (create_type === 2) {
      createBrigadeDialog.componentInstance.brigadeHeadListInBrigade = this.getMainEmployers();
    }

    createBrigadeDialog.componentInstance.user = this.user;
    createBrigadeDialog.componentInstance.sector = this.sector;
    createBrigadeDialog.componentInstance.currentBrigade = this.brigade;
    createBrigadeDialog.componentInstance.createType = create_type;
    createBrigadeDialog.result.then(
      () => {
        this.onUpdateWidget.emit();
      },
      () => {}
    );
  }

  public onMoveUserNewBrigadeDialog() {
    let mode;
    let brigadeHeadListInBrigade;

    // Перенос незаасайненного монтажника, либо не бригадира в бригаду
    if ((has(this.user, 'brigade') && !this.user.brigade && !this.brigade) ||
      (this.user && this.brigade && this.user.u_id !== this.brigade.brigade_head.u_id)) {
      mode = 'moveUser';
    } else if (this.user && this.brigade && this.user.u_id === this.brigade.brigade_head.u_id) {
      brigadeHeadListInBrigade = this.getMainEmployers();

      // Проверка есть ли еще в бригаде сотрудники которые могут быть бригадиром.
      if (this.checkMainEmployers()) {
        mode = 'moveBrigadeHead';
      } else {
        if (!this.checkWorkersInBrigade()) {
          mode = 'moveBrigadeHeadAndDrop';
        } else {
          this.showOnlyTraineesWarning();
          return;
        }
      }
    }

    let moveBrigadeDialog = this.modalService.open(MoveUserNewBrigadeModalComponent, {
      ariaLabelledBy: 'modal-basic-title',
      windowClass: 'modal-wrapper',
      backdrop: 'static',
    });

    moveBrigadeDialog.componentInstance.mode = mode;
    moveBrigadeDialog.componentInstance.user = this.user;
    moveBrigadeDialog.componentInstance.brigade = this.brigade || null;
    moveBrigadeDialog.componentInstance.sector = this.sector;

    switch (mode) {
      case 'moveUser':
        moveBrigadeDialog.componentInstance.title = 'Перенос сотрудника в бригаду';
        moveBrigadeDialog.componentInstance.description = 'Сотрудник ' + this.user.employee.full_name + ' будет перенесен в бригаду.';
        moveBrigadeDialog.componentInstance.currentBrigade = this.brigade;
        break;
      case 'moveBrigadeHead':
        moveBrigadeDialog.componentInstance.title = 'Перенос бригадира в другую бригаду';
        moveBrigadeDialog.componentInstance.description = 'Бригадир ' + this.user.employee.full_name + ' будет перенесен в другую бригаду.';
        moveBrigadeDialog.componentInstance.brigadeHeadListInBrigade = brigadeHeadListInBrigade;
        moveBrigadeDialog.componentInstance.currentBrigade = this.brigade;
        break;
      case 'moveBrigadeHeadAndDrop':
        moveBrigadeDialog.componentInstance.title = 'Перенос единственного сотрудника';
        moveBrigadeDialog.componentInstance.description =
          'Единственный сотрудник бригады ' +
          this.user.employee.full_name +
          ' будет перенесен в другую бригаду. Бригада "' +
          this.brigade.brigade_name +
          '" будет расформирована. Заявки, назначенные на бригаду, будут переведены в статус “Не отправлена”. ';
        moveBrigadeDialog.componentInstance.brigadeHeadListInBrigade = brigadeHeadListInBrigade;
        moveBrigadeDialog.componentInstance.currentBrigade = this.brigade;
        break;
      default:
        break;
    }

    moveBrigadeDialog.result.then(
      () => {
        this.onUpdateWidget.emit(true);
      },
      () => {}
    );
  }

  public onRemoveUserFromBrigade() {
    let removeUserConfirmDialog;

    if (this.user && this.brigade && this.user.u_id === this.brigade.brigade_head.u_id && !this.checkWorkersInBrigade()) {
      removeUserConfirmDialog = this.modalService.open(ConfirmModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-wrapper',
        backdrop: 'static',
      });

      removeUserConfirmDialog.componentInstance.title = 'Удаление единственного сотрудника';
      removeUserConfirmDialog.componentInstance.description =
        'Удалить сотрудника из бригады можно только при' +
        ' увольнении. Единственный сотрудник бригады ' +
        this.user.employee.full_name +
        ' будет удален. <br>' +
        '– Бригада "' +
        this.brigade.brigade_name +
        '" будет расформирована. <br>' +
        '– Заявки, назначенные на бригаду, будут переведены в статус “Не отправлена”. ';
      removeUserConfirmDialog.componentInstance.successButtonName = 'Удалить';
      removeUserConfirmDialog.componentInstance.abortButtonName = 'Отмена';
      removeUserConfirmDialog.result.then(
        () => {
          this.removeUser({
            new_head: null,
            mounter: this.user.u_id,
          });
        },
        () => {}
      );
    } else if (this.user && this.brigade && this.user.u_id === this.brigade.brigade_head.u_id && this.checkWorkersInBrigade()) {
      if (!this.checkMainEmployers()) {
        this.showOnlyTraineesWarning();
        return false;
      }

      let removeUserFromBrigadeDialog = this.modalService.open(RemoveUserFromBrigadeComponent, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-wrapper',
        backdrop: 'static',
      });

      removeUserFromBrigadeDialog.componentInstance.brigadeHeadListInBrigade = this.getMainEmployers();
      removeUserFromBrigadeDialog.componentInstance.user = this.user;
      removeUserFromBrigadeDialog.componentInstance.sector = this.sector;
      removeUserFromBrigadeDialog.componentInstance.currentBrigade = this.brigade;
      removeUserFromBrigadeDialog.result.then(
        () => {
          this.onUpdateWidget.emit();
        },
        () => {}
      );
    } else if (this.user && this.brigade && this.user.u_id !== this.brigade.brigade_head.u_id) {
      removeUserConfirmDialog = this.modalService.open(ConfirmModalComponent, {
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'modal-wrapper',
        backdrop: 'static',
      });

      removeUserConfirmDialog.componentInstance.title = 'Удаление сотрудника из бригады';
      removeUserConfirmDialog.componentInstance.description =
        'Удалить сотрудника из бригады можно только при' +
        ' увольнении. Сотрудник ' +
        this.user.employee.full_name +
        ' будет удален из бригады " ' +
        this.brigade.brigade_name +
        ' "';
      removeUserConfirmDialog.componentInstance.successButtonName = 'Удалить';
      removeUserConfirmDialog.componentInstance.abortButtonName = 'Отмена';
      removeUserConfirmDialog.result.then(
        () => {
          this.removeUser({
            mounter: this.user.u_id,
            new_head: null,
          });
        },
        () => {}
      );
    }
  }

  public createNewBrigade() {
    const brigadeName =  `Бригада ${this.user.employee.full_name.split(' ')[0]}`;

    this.brigadesService
      .createBrigade({
        new_head: null,
        brigade_name: brigadeName,
        head: this.user.u_id,
        sector_id: this.sector.sector_id,
      })
      .subscribe(
        () => {
          this.onUpdateWidget.emit();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  public makeMainHeadInCurrentBrigade() {
    this.brigadesService
      .moveUserNewBrigadeBrigade({
        brigade: this.brigade.id,
        new_head: this.user.u_id,
        mounter: this.brigade.brigade_head.u_id,
      })
      .subscribe(
        () => {
          this.onUpdateWidget.emit();
        },
        (error) => {
          console.log(error);
        }
      );
  }

  public removeUser(data) {
    this.brigadesService.removeUserFromBrigade(this.brigade.id, data).subscribe(
      () => {
        this.onUpdateWidget.emit(true);
      },
      (error) => {
        console.log(error);
      }
    );
  }
}
